<template>
  <caption class="d-block">
    <div class="p-3 text-center">
      <i class="pi pi-exclamation-circle fs-2 mb-2 text-secondary"></i>
      <h2 class="text-center fs-6">{{ message }}</h2>

    </div>
  </caption>
</template>

<script setup>
// ===============================
// IMPORTS
// ===============================
// Vue Core

// Components

// Composables

// Stores

// Constants and Utils

// ===============================
// PROPS & EMITS
// ===============================
defineProps({
    message: {
        type: String,
        default: 'No data.'
    }
});

// ===============================
// COMPOSABLES & STORES
// ===============================

// ===============================
// REACTIVE STATE
// ===============================

// ===============================
// CONSTANTS
// ===============================

// ===============================
// COMPUTED PROPERTIES
// ===============================

// ===============================
// METHODS
// ===============================

// ===============================
// WATCHERS
// ===============================

// ===============================
// LIFECYCLE HOOKS
// ===============================

// ===============================
// EXPOSE
// ===============================

</script>